module.exports = __webpack_public_path__ + "img/dsci0128.f40c10ec.jpg";